// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"de29278b","842":"dd9f42ee"}[chunkId] + ".chunk.js";
};